<template>
    <div>
        <div class="simple-form flex col-4">
            <div class="form-group center">
                <div class="form-label">
                    <label>业务范围名称</label>
                </div>
                <div class="form-value">
                    <span>{{ merchtBizPermScope.name || '' }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>业务单元类型</label>
                </div>
                <div class="form-value">
                    <span>{{ bizUnitTypeMap[merchtBizPermScope.bizUnitType] || '' }}</span>
                </div>
            </div>
            <!--            <div class="form-group center">-->
            <!--                <div class="form-label">-->
            <!--                    <label>是否门店专用</label>-->
            <!--                </div>-->
            <!--                <div class="form-value">-->
            <!--                    <span>{{ merchtBizPermScope.shopFlag ? '是' : '否' }}</span>-->
            <!--                </div>-->
            <!--            </div>-->
            <!--            <div class="form-group center" v-if="!merchtBizPermScope.shopFlag">-->
            <!--                <div class="form-label">-->
            <!--                    <label>适用级别</label>-->
            <!--                </div>-->
            <!--                <div class="form-value">-->
            <!--                    <span v-if="merchtBizPermScope.comLevel1">一级机构</span>-->
            <!--                    <span v-else-if="merchtBizPermScope.comLevel2">二级机构</span>-->
            <!--                    <span v-else-if="merchtBizPermScope.comLevel3">三级机构</span>-->
            <!--                    <span v-else-if="merchtBizPermScope.comLevel4">四级机构</span>-->
            <!--                </div>-->
            <!--            </div>-->
            <!--            <div class="form-group center">-->
            <!--                <div class="form-label">-->
            <!--                    <label>业务权限限制</label>-->
            <!--                </div>-->
            <!--                <div class="form-value">-->
            <!--                    <span>{{ merchtBizPermScope.bizPermFlag ? '启用' : '关闭' }}</span>-->
            <!--                </div>-->
            <!--            </div>-->
            <!--            <div class="form-group center" v-if="merchtBizPermScope.bizPermFlag">-->
            <!--                <div class="form-label">-->
            <!--                    <label>业务权限模式</label>-->
            <!--                </div>-->
            <!--                <div class="form-value">-->
            <!--                    <span v-if="merchtBizPermScope.bizPermOrgFlag == 1">仅本机构</span>-->
            <!--                    <span v-if="merchtBizPermScope.bizPermOrgFlag == 3">本机构及以下</span>-->
            <!--                </div>-->
            <!--            </div>-->
        </div>
        <el-table :data="merchtTplRoleList" border style="width: 100%">
            <el-table-column prop="confName" label="职责权限名称" align="left" show-overflow-tooltip></el-table-column>
            <el-table-column prop="createTime" label="创建时间" align="left" width="300" show-overflow-tooltip></el-table-column>
        </el-table>
    </div>
</template>

<script>
import { Utils } from '../../app.base'
import { Vue, MsgBox, Routes } from '../../app.vues'

import merchtAllApi from '../../api/merchtAll'

export default {
    name: 'swb-mercht-tpl-role-ref-list',
    desc: '职责业务范围-查看已关联的职责权限',
    props: ['merchtBizPermScope'],
    data: function () {
        return {
            bizUnitTypeMap: getEnumMap('bizUnitType', 'value2text'),
            merchtTplRoleList: []
        }
    },
    created: function () {
        this.getMerchtTplRoleList();
    },
    methods: {
        getMerchtTplRoleList() {
            let self = this;
            let postData = {
                bizPermScopId: this.merchtBizPermScope.id
            };
            let theLoading = MsgBox.loading();
            merchtAllApi.getMerchtTplRoleListForRef(postData, function (result) {
                theLoading.close();
                if(result.type == 'info') {
                    self.merchtTplRoleList = result.data || [];
                } else {
                    MsgBox.warning(result.message);
                }
            });
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/compo/authx/MerchtTplRoleRefList.vue